import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import SYEPLogo from "@/assets/certificates/syep-logo.png";
import HLLogo from "@/assets/certificates/hnl-logo.png";
import StarlightTwinkle from "@/assets/certificates/starlight-twinkle.png";
import CornerImage from "@/assets/certificates/syep-certificate-corner-graphic.png";
import ProximaNovaReg from "@/assets/fonts/proximanova_regular.ttf";
import ProximaNovaBold from "@/assets/fonts/proximanova_bold.otf";
import Nunito from "@/assets/fonts/Nunito-Bold.ttf";
import Mulish from "@/assets/fonts/Mulish-Medium.ttf";
import MulishBold from "@/assets/fonts/Mulish-Bold.ttf";

Font.register({ family: "ProximaNova", src: ProximaNovaReg });
Font.register({
  family: "ProximaNovaBold",
  src: ProximaNovaBold,
  fontWeight: "bold",
});
Font.register({ family: "Nunito", src: Nunito, fontWeight: "bold" });
Font.register({ family: "Mulish", src: Mulish, fontWeight: 400 });
Font.register({ family: "MulishBold", src: MulishBold, fontWeight: 700 });

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#fff",
    // padding: 20,
  },
  cornerImage: {
    position: "absolute",
    right: -25,
    top: -25,
    width: 190,
    height: 190,
  },
  outerContainer: {
    flex: 1,
    padding: 25,
    backgroundColor: "#FFD100",
  },
  outerContainerProskills: {
    flex: 1,
    padding: 25,
    backgroundColor: "#F59213",
  },
  outerContainerProskillsIBM: {
    flex: 1,
    padding: 25,
    backgroundColor: "#750937",
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
    padding: 20,
  },
  body: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  logo: {
    marginBottom: 20,
  },
  header: {
    flexDirection: "row",
  },
  subHeader: {},
  title: {
    fontSize: 18,
    marginBottom: 20,
    marginTop: 20,
    fontFamily: "Mulish",
  },
  name: {
    fontSize: 42,
    fontWeight: 700,
    marginBottom: 20,
    color: "#8420B4",
    fontFamily: "Nunito",
  },
  subtitle: {
    fontSize: 18,
    marginBottom: 5,
  },
  text: {
    fontSize: 14,
    marginBottom: 5,
    fontFamily: "Mulish",
  },
  textDescription: {
    fontSize: 14,
    marginBottom: 5,
    fontFamily: "Mulish",
    maxWidth: 505,
  },
  skillsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    marginTop: 10,
    maxWidth: 460,
  },
  skillTag: {
    backgroundColor: "#E2B6FF",
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 8,
    fontSize: 10,
    color: "#8420B4",
    fontFamily: "MulishBold",
  },
  leftBody: {
    width: "60%",
  },
  rightBody: {
    width: "40%",
  },
  badgeContainer: {
    position: "absolute",
    right: 30,
    bottom: 30,
  },
  footer: {
    position: "absolute",
    bottom: 20,
    marginTop: 20,
    fontSize: 12,
  },
  inline: {
    flexDirection: "row",
    width: 380,
    marginRight: 55,
  },
  footerTextTop: {
    minWidth: 135,
    marginRight: 35,
    fontFamily: "Mulish",
    fontSize: 16,
  },
  footerText: {
    minWidth: 135,
    marginRight: 35,
    fontFamily: "Mulish",
    fontSize: 12,
  },
  footerBar: {
    minWidth: 135,
    height: 2,
    marginRight: 35,
    backgroundColor: "black",
    marginTop: 10,
    marginBottom: 10,
  },
});

// PDF document component
const CertificatePdf = ({
  award,
  estimatedCertTime,
  skills,
  badge,
  completionDate,
  currentUser,
  isProskillsAward,
  isIBMAward,
  isGenericWorkforceAward,
}) => {
  if (isProskillsAward) {
    return (
      <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>
          <View
            style={
              isIBMAward
                ? styles.outerContainerProskillsIBM
                : styles.outerContainerProskills
            }
          >
            <View style={styles.container}>
              <Image src={CornerImage} style={styles.cornerImage} />
              <View style={styles.logo}>
                <Image
                  src={SYEPLogo}
                  style={{ width: "230px", height: "70px" }}
                />
              </View>
              <View style={styles.header}>
                <Text style={styles.title}>THIS CERTIFICATE IS AWARDED TO</Text>
                <Image
                  src={StarlightTwinkle}
                  style={{ width: "36px", height: "36px", marginTop: -10 }}
                />
              </View>
              <View style={styles.subHeader}>
                <Text style={styles.name}>
                  {currentUser.firstName} {currentUser.lastName}
                </Text>
                <Text style={[styles.textDescription, { marginBottom: 20 }]}>
                  for successfully completing the{" "}
                  <Text style={{ fontFamily: "MulishBold" }}>{award.name}</Text>
                  , {award.awardDescription}
                </Text>
              </View>
              <View style={styles.body}></View>
              <View style={styles.footer}>
                <View style={styles.inline}>
                  <Text style={styles.footerTextTop}>{completionDate}</Text>
                  <Text style={styles.footerTextTop}>
                    {estimatedCertTime} hours
                  </Text>
                </View>
                <View style={styles.inline}>
                  <View style={styles.footerBar} />
                  <View style={styles.footerBar} />
                </View>
                <View style={styles.inline}>
                  <Text style={styles.footerText}>Date Awarded</Text>
                  <Text style={styles.footerText}>Training Length</Text>
                </View>
              </View>
            </View>
            <Image
              src={award.image?.url}
              style={{
                width: 280,
                height: 280,
                padding: 20,
                position: "absolute",
                bottom: 20,
                right: 20,
              }}
            />
          </View>
        </Page>
      </Document>
    );
  } else {
    return (
      <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>
          <View style={styles.outerContainer}>
            <View style={styles.container}>
              <Image src={CornerImage} style={styles.cornerImage} />
              <View style={styles.logo}>
                {isGenericWorkforceAward ? (
                  <Image
                    src={HLLogo}
                    style={{ width: "280px", height: "56px" }}
                  />
                ) : (
                  <Image
                    src={SYEPLogo}
                    style={{ width: "230px", height: "70px" }}
                  />
                )}
              </View>
              <View style={styles.header}>
                <Text style={styles.title}>THIS CERTIFICATE IS AWARDED TO</Text>
                <Image
                  src={StarlightTwinkle}
                  style={{ width: "36px", height: "36px", marginTop: -10 }}
                />
              </View>
              <View style={styles.subHeader}>
                <Text style={styles.name}>
                  {currentUser.firstName} {currentUser.lastName}
                </Text>
                <Text style={styles.text}>
                  for successfully completing the{" "}
                  <Text style={{ fontFamily: "MulishBold" }}>
                    Hats &amp; Ladders Workforce Readiness digital training
                    {/* {isGenericWorkforceAward
                      ? "Hats & Ladders Workforce Readiness "
                      : "2025 Summer Youth Employment Program Orientation"} */}
                  </Text>
                  {isGenericWorkforceAward ? (
                    <Text style={styles.text}>virtual training.</Text>
                  ) : (
                    <></>
                  )}
                </Text>
                <Text style={[styles.text, { marginBottom: 20 }]}>
                  {isGenericWorkforceAward
                    ? ""
                    : "provided by the New York City Department of Youth & Community Development."}
                </Text>
              </View>
              <View style={styles.body}>
                <Text style={styles.text}>
                  Knowledge and skills developed include:
                </Text>
              </View>
              <View style={styles.skillsContainer}>
                {skills.map((skill, index) => (
                  <Text key={index} style={styles.skillTag}>
                    {skill}
                  </Text>
                ))}
              </View>
              <View style={styles.footer}>
                <View style={styles.inline}>
                  <Text style={styles.footerTextTop}>{completionDate}</Text>
                  <Text style={styles.footerTextTop}>
                    {estimatedCertTime} hours
                  </Text>
                  {isGenericWorkforceAward ? (
                    <></>
                  ) : (
                    <Text style={styles.footerTextTop}>Keith Howard</Text>
                  )}
                </View>
                <View style={styles.inline}>
                  <View style={styles.footerBar} />
                  <View style={styles.footerBar} />
                  {isGenericWorkforceAward ? (
                    <></>
                  ) : (
                    <View style={styles.footerBar} />
                  )}
                </View>
                <View style={styles.inline}>
                  <Text style={styles.footerText}>Date Awarded</Text>
                  <Text style={styles.footerText}>Training Length</Text>
                  {isGenericWorkforceAward ? (
                    <></>
                  ) : (
                    <Text style={styles.footerText}>DYCD Commissioner</Text>
                  )}
                </View>
              </View>
            </View>
            <Image
              src={badge}
              style={{
                width: 260,
                height: 260,
                padding: 20,
                position: "absolute",
                bottom: 20,
                right: 20,
              }}
            />
          </View>
        </Page>
      </Document>
    );
  }
};

export default CertificatePdf;
